import React, { useMemo } from 'react';
import parseFormDefinition from '../util/parseFormDefinition';
import UWEEntityFormComponent from './UWEEntityFormComponent';

function UWEFormComponent({
  slug,
  form,
  readonly,
  currentStatus,
  currentEntity,
  renderFormSubmitted,
  overrideOnSubmit,
  onSubmit,
  wfAccessToken,
  ...props
}) {
  const formArgs = useMemo(() => parseFormDefinition(form, currentEntity), [form, currentEntity]);
  const FormComponent = useMemo(
    () =>
      formArgs &&
      UWEEntityFormComponent({
        ...formArgs,
        renderFormSubmitted,
        overrideOnSubmit,
        onSubmit,
        wfAccessToken,
      }),
    [formArgs, overrideOnSubmit]
  );

  return FormComponent ? (
    <FormComponent
      currentEntity={currentEntity}
      currentStatus={currentStatus}
      readonly={readonly || formArgs?.readonly}
      slug={slug}
      wfAccessToken={wfAccessToken}
      {...props}
    />
  ) : null;
}

export default UWEFormComponent;
